/**
 * DevExtreme (esm/__internal/ui/collection/async.js)
 * Version: 24.1.8
 * Build date: Mon Dec 16 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import CollectionWidgetAsync from "../../../ui/collection/ui.collection_widget.async";
import CollectionWidgetEdit from "./edit";
const TypedCollectionWidget = CollectionWidgetAsync;
export default TypedCollectionWidget;
